exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#wacg-wrapper label{display:inline-block;padding-bottom:5px}", ""]);

// exports
